'use client';

import { type JSX, useEffect } from 'react';
import { useAppRouter } from '@/lib/network/use-app-router';

interface ReferralRedirectProps {
  /** Validated referral code (X handle or UUID). `null` when validation failed. */
  referralCode: string | null;
}

/**
 * Replaces the `/r/[code]` URL with `/`. The cookie set is handled
 * server-side by middleware on the same request, so this client island
 * only needs to navigate the visible URL away from the share path.
 */
export function ReferralRedirect(_props: ReferralRedirectProps): JSX.Element | null {
  const router = useAppRouter();

  useEffect((): void => {
    router.replace('/');
  }, [router]);

  return null;
}
